import { render } from "./final.vue?vue&type=template&id=07b0a4d7&ts=true"
import script from "./final.vue?vue&type=script&lang=ts"
export * from "./final.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__